module.exports = __webpack_public_path__ + "static/media/06_andinvainthedreamer.3d6eebf4.jpg";